import React, { useEffect, useState } from "react";
import { useNotaire } from "../context/NotaireContext";
import ListItemContact from '../components/ListItemContact';
import EmptyState from "../components/EmptyState";
import "react-toastify/dist/ReactToastify.css";
import { Heading } from '../components/catalyst/heading';
import { AlertMessage } from "../components/MessageAlert";
import { EnvelopeIcon } from '@heroicons/react/24/solid';

function Contact() {
  const context = useNotaire();
  const [messages, setMessages] = useState([]);

  // Sync initial + quand le contexte change
  useEffect(() => {
    setMessages(Array.isArray(context.demandeContact) ? context.demandeContact : []);
  }, [context.demandeContact]);

  if (!context.user) return null;

  const handleLocalDelete = (deletedId) => {
    // MAJ immédiate de la liste locale
    setMessages((prev) => prev.filter((m) => m.id !== deletedId));
  };

  const hasNone = messages.length === 0;

  return (
    <div className="container">
      <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
        <Heading>Vos demandes de contact</Heading>
      </div>

      <div className="mt-3">
        <AlertMessage
          type="info"
          message="Retrouvez ici les messages que les utilisateurs vous envoient depuis votre page notaire."
        />

        {/* État vide */}
        {hasNone && (
          <div className="overflow-hidden rounded-lg bg-white shadow-sm mt-3 text-center">
            <EmptyState
              icon={EnvelopeIcon}
              title="Aucun message reçu"
              description="Lorsqu’une personne vous contactera depuis votre page notaire, vous serez averti(e) par email."
            />
          </div>
        )}

        {/* Liste triée (plus récents en premier) */}
        {!hasNone && (
          <div className="overflow-hidden mt-3">
            <ul className="divide-y divide-gray-50">
              {[...messages]
                .sort((a, b) => new Date(b.fields.date) - new Date(a.fields.date))
                .map((col) => (
                  <ListItemContact
                    key={col.id}
                    id={col.id}                              // ⚠️ utilisé pour DELETE Airtable
                    nom={col.fields.nom}
                    prenom={col.fields.prenom}
                    message={col.fields.message}
                    telephone={col.fields.telephone}
                    email={col.fields.email}
                    date={col.fields.date}
                    type={col.fields.type_demande}
                    onDelete={handleLocalDelete}             // ✅ MAJ locale après suppression
                  />
                ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default Contact;